<section class="terms-and-condition-section">
    <div class="section__heading-container">
        <div class="section__heading-container__heading-text">Terms & Condition</div>
    </div>
    <div class="section__condition-list">
        <ul>
            <li *ngFor="let conditions of termsAndConditions">{{ conditions }}</li>
        </ul>
    </div>
</section>